import clsx from "clsx";

// Inline SVG placeholder (works in Puppeteer PDF export without a web server)
const FALLBACK_SVG = `data:image/svg+xml,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"><rect fill="#f1f5f9" width="400" height="300"/><text x="200" y="150" text-anchor="middle" dominant-baseline="central" font-family="sans-serif" font-size="14" fill="#94a3b8">Aucune image</text></svg>'
)}`;

interface IImageComponent {
  image?: string;
  resizeMode?: "contain" | "cover";
  aspectRatio?: "video" | "square" | "auto";
  alt?: string;
}
function ImageComponent({
  image,
  resizeMode,
  aspectRatio,
  alt,
}: IImageComponent) {
  const boxClassName = clsx(
    "w-full",
    aspectRatio === "video"
      ? "aspect-video"
      : aspectRatio === "square"
      ? "aspect-square"
      : "aspect-auto"
  );
  const imgClassName = clsx(
    resizeMode === "contain" ? "object-contain" : "object-cover",
    "object-center w-full h-full rounded-lg overflow-hidden"
  );

  return (
    <div className={boxClassName}>
      <img src={image || FALLBACK_SVG} className={imgClassName} alt={alt} />
    </div>
  );
}

export default ImageComponent;
